import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import {
  headerButtonsColor,
  headerIconSize,
  DropDownListButtonsColor,
  showSnackBar,
  padZeros,
} from 'utils/Global';
import {
  GetSaveDiscardButtonsParams,
  GetIngredientHeaderButtonsParams,
  GetExportButtonsListParams,
} from 'components/ingredients/IngredientConstants';
import { IDropDownList } from 'components/customComponents/CommonComponents/RMDropDownList';
import { IngredientTableRow } from 'business/models/Models';
import copy from 'copy-html-to-clipboard';

export const getSaveDiscardButtons = (params: GetSaveDiscardButtonsParams) => {
  const { enableButtons, onSave, onDiscard } = params;
  const saveDiscardButtons: Array<RMCustomButtonProps> = [
    {
      iconProps: { name: 'Save', fill: '#24A148', ...headerIconSize },
      title: 'Save',
      isDisabled: !enableButtons,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: onSave,
    },
    {
      iconProps: { name: 'Discard', fill: '#DA1E28', ...headerIconSize },
      title: 'Discard',
      isDisabled: !enableButtons,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: onDiscard,
    },
  ];

  return saveDiscardButtons;
};

export const getIngredientHeaderButtons = (params: GetIngredientHeaderButtonsParams) => {
  const {
    isDisabled,
    modelRefCurrent,
    addIngredientType,
    addVendor,
    addLiquidClass,
    printLabels,
    exportsList,
    mergeIngredients,
    isMergeIngredientDisabled,
    isDeleteDisabled,
    showDeleteIngredientWarning,
    openIngredient,
    isOpenIngredientDisabled,
    createIngredient,
    addProteinType,
  } = params;

  const infoHeaderButtons: Array<RMCustomButtonProps> = [
    {
      iconProps: { name: 'AddLayer', fill: headerButtonsColor, ...headerIconSize },
      title: 'Create New Ingredient',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: createIngredient,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'AddIngredient', fill: headerButtonsColor, ...headerIconSize },
      title: 'Open',
      isDisabled: isOpenIngredientDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: openIngredient,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'Delete', fill: headerButtonsColor, ...headerIconSize },
      title: 'Delete Ingredient',
      isDisabled: isDeleteDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: showDeleteIngredientWarning,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: {
        name: 'MergeIngredients',
        fill: headerButtonsColor,
        ...headerIconSize,
      },
      title: 'Merge Ingredient',
      isDisabled: isMergeIngredientDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: mergeIngredients,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: {
        name: 'LiquidClassUnion',
        fill: headerButtonsColor,
        ...headerIconSize,
      },
      title: 'Liquid Class',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: addLiquidClass,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'AddIngredient', fill: headerButtonsColor, ...headerIconSize },
      title: 'Ingredient Type',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: addIngredientType,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'AddIngredient', fill: headerButtonsColor, ...headerIconSize },
      title: 'Protein Type',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: addProteinType,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'Vendor', fill: headerButtonsColor, ...headerIconSize },
      title: 'Vendor',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: addVendor,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'PrintBarcode', fill: headerButtonsColor, ...headerIconSize },
      title: 'Print Label',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: printLabels,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'Import', fill: headerButtonsColor, ...headerIconSize },
      title: 'Import',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: modelRefCurrent,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'Export', fill: headerButtonsColor, ...headerIconSize },
      title: 'Export',
      isDisabled: isDisabled,
      dropDownList: exportsList,
      showChevronIcon: true,
      chevronIconInitialAngle: 315,
      chevronIconPosition: 'end',
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: () => {},
      mainContainerClass: 'justify-start',
    },
  ];
  return infoHeaderButtons;
};

export const useExportButtonsList = (params: GetExportButtonsListParams) => {
  const {
    exportIngredientsToExcel,
    exportIngredientsToText,
    exportIngredientsToDoc,
    exportIngredientsToXML,
    exportIngredientsToXMLSpreadsheet,
  } = params;

  const exportsList: IDropDownList[] = [
    {
      label: 'Excel File',
      iconProps: { name: 'ExcelFile', fill: DropDownListButtonsColor },
      onClick: exportIngredientsToExcel,
      isDisabled: false,
    },
    {
      label: 'Word File',
      iconProps: { name: 'DocFile', fill: DropDownListButtonsColor },
      onClick: exportIngredientsToDoc,
      isDisabled: false,
    },
    {
      label: 'Text File',
      iconProps: { name: 'TextFile', fill: DropDownListButtonsColor },
      onClick: exportIngredientsToText,
      isDisabled: false,
    },
    {
      label: 'XML',
      iconProps: { name: 'XMLFile', fill: DropDownListButtonsColor },
      onClick: exportIngredientsToXML,
      isDisabled: false,
    },
    {
      label: 'XML Spreadsheet',
      iconProps: { name: 'DocFile', fill: DropDownListButtonsColor },
      onClick: exportIngredientsToXMLSpreadsheet,
      isDisabled: false,
    },
  ];
  return exportsList;
};

export const isBufferStockConsistentAmongIngredients = (
  ingredients: IngredientTableRow[][],
) => {
  return (
    ingredients[0].some((item) => item.isBuffer == true) ===
    ingredients[1].some((item) => item.isBuffer == true)
  );
};

const INGREDIENT_CLIPBOARD_HEADERS = [
  'ID',
  'Type',
  'Name',
  'Short Name',
  'Default Stock Number',
  'Conc. Units',
  'Stock Conc.',
  'Low Conc.',
  'High Conc.',
  'Liquid Class',
  'Stock Min pH',
  'Stock Max pH',
];

const getIngredientClipboardCellValue = (value: string | number | null | undefined) =>
  value == null ? '' : String(value);

const getIngredientClipboardRowValues = (ingredient: IngredientTableRow): string[] => [
  padZeros(ingredient.id, 5),
  getIngredientClipboardCellValue(ingredient.type),
  getIngredientClipboardCellValue(ingredient.name),
  getIngredientClipboardCellValue(ingredient.shortName),
  ingredient.defaultStockNumber == null ? '' : padZeros(ingredient.defaultStockNumber, 3),
  getIngredientClipboardCellValue(ingredient.concUnit),
  getIngredientClipboardCellValue(ingredient.stockConc),
  getIngredientClipboardCellValue(ingredient.lowConc),
  getIngredientClipboardCellValue(ingredient.highConc),
  getIngredientClipboardCellValue(ingredient.liquidClassName),
  getIngredientClipboardCellValue(ingredient.stockMinPh),
  getIngredientClipboardCellValue(ingredient.stockMaxPh),
];

const buildIngredientsClipboardTsv = (ingredients: IngredientTableRow[]): string => {
  return [
    INGREDIENT_CLIPBOARD_HEADERS.join('\t'),
    ...ingredients.map((ingredient) =>
      getIngredientClipboardRowValues(ingredient).join('\t'),
    ),
  ].join('\r\n');
};

const buildIngredientsClipboardHtml = (ingredients: IngredientTableRow[]): string => {
  const tab = '</td><td>';
  let rows = `<tr><th>${INGREDIENT_CLIPBOARD_HEADERS.join('</th><th>')}</th></tr>`;
  ingredients.forEach((ingredient) => {
    rows += `<tr><td>${getIngredientClipboardRowValues(ingredient).join(
      tab,
    )}</td></tr>\n`;
  });

  return `<!Doctype html><html><head><title></title></head><body style="font-family:'Times New Roman'"><table border="1">${rows}</table></body></html>`;
};

/** Fallback for environments that block ClipboardItem writes. */
const copyIngredientsHtmlFallback = (ingredients: IngredientTableRow[]): boolean => {
  try {
    copy(buildIngredientsClipboardHtml(ingredients), {
      asHtml: true,
    });
    return true;
  } catch (err) {
    console.error(err);
    showSnackBar('Could not copy to clipboard');
    return false;
  }
};

export const copyIngredientsToClipboard = async (
  ingredients: IngredientTableRow[],
): Promise<boolean> => {
  if (!ingredients?.length) {
    return false;
  }

  try {
    const tsv = buildIngredientsClipboardTsv(ingredients);
    const html = buildIngredientsClipboardHtml(ingredients);

    // Provide both formats: HTML for Excel/Sheets columns, TSV for text editors
    if (navigator.clipboard?.write && typeof ClipboardItem !== 'undefined') {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([tsv], { type: 'text/plain' }),
        }),
      ]);
    } else {
      copy(html, {
        asHtml: true,
      });
    }

    return true;
  } catch (err) {
    console.error(err);
    return copyIngredientsHtmlFallback(ingredients);
  }
};

export const getTypedIngredientByIngredientId = (
  ingredientsData: IngredientTableRow[],
  ingredientsIds: number[],
): IngredientTableRow[][] => {
  return Object.values(
    ingredientsData.reduce((groupedRecords, record) => {
      const id = record.id;

      if (ingredientsIds.includes(id)) {
        if (!groupedRecords[id]) {
          groupedRecords[id] = [];
        }

        groupedRecords[id].push(record);
      }

      return groupedRecords;
    }, {}),
  );
};
